import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "carts",
  initialState: {
    order : null,
    transferMoney : null,
  },
  reducers: {
    setUserOrder: (user, action) => {
      user.order = action.payload; 
    },
    setTransferMoney: (user, action) => {
      user.transferMoney = action.payload; 
    },
  },
});

export const {
  setUserOrder,
  setTransferMoney,
} = slice.actions;

export default slice.reducer;
